import { render, staticRenderFns } from "./SimpleSubmissionDetail.vue?vue&type=template&id=752388ba&scoped=true&"
import script from "./SimpleSubmissionDetail.vue?vue&type=script&lang=js&"
export * from "./SimpleSubmissionDetail.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSubmissionDetail.vue?vue&type=style&index=0&id=752388ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752388ba",
  null
  
)

export default component.exports